'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_s_util_Right$() {
}
export { $c_s_util_Right$ as $c_s_util_Right$ };
$p = $c_s_util_Right$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_s_util_Right$;
/** @constructor */
function $h_s_util_Right$() {
}
export { $h_s_util_Right$ as $h_s_util_Right$ };
$h_s_util_Right$.prototype = $p;
$p.b = (function() {
  return "Right";
});
var $d_s_util_Right$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_s_util_Right$, "scala.util.Right$", ({
  wf: 1
}));
export { $d_s_util_Right$ as $d_s_util_Right$ };
var $n_s_util_Right$;
function $m_s_util_Right$() {
  if ((!$n_s_util_Right$)) {
    $n_s_util_Right$ = new $c_s_util_Right$();
  }
  return $n_s_util_Right$;
}
export { $m_s_util_Right$ as $m_s_util_Right$ };
